module.exports = __webpack_public_path__ + "static/media/carousel_2.31f17536.jpg";